import React, { useContext } from 'react';
import "./style/OnHoldPlan.scss";
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import CustomTypography from '../CustomTypography';
import { ReactComponent as OnHold } from '../../assets/subscription/On Hold.svg';
import { Divider } from '@mui/material';
import CommonUtil from '../../util/CommonUtils';

const OnHoldPlan = ({ title="NO ACTIVE SUBSCRIPTION",planName = "Premium Plan", renewalDate = "Plan ended on 01st February 2025" }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);

    const typographyStyle = {
        fontFamily: "Gotham",
        textOverflow: "ellipsis", // Corrected typo
        whiteSpace: "nowrap",
        overflow: "hidden",
        color: mode == "dark" ? "#F8F8F8" : "#242424",
        opacity: "0.8",
        fontSize: "13px",
        lineHeight: "30px",
    }
    return (
        <div className='onhold-container'>
            <div style={{ display: "flex" }}>
                <OnHold />
                <div className='status-text'
                    style={{
                        color: mode == "dark" ? "#F8F8F8" : "#242424",
                        paddingTop:
                        CommonUtil.getOS() === "MacOS" ? "11px" : "0px",
                    }}
                >{title}</div>
            </div>
            <div className='onhold-content'
                style={{
                    backgroundColor: mode == "dark" ? "#333333" : "#FFFFFF"
                }}
            >
                <CustomTypography title={planName}
                    component={{
                        typography: {
                            sx: { ...typographyStyle }
                        }
                    }}
                >{planName}</CustomTypography>
                <span
                    style={{
                        color: mode == "dark" ? "#F8F8F8" : "#242424",
                        opacity: "0.8",
                        fontSize: "13px",
                        lineHeight: "30px",
                        margin: "0 5px"
                    }}>{"|"}</span>
                <CustomTypography title={renewalDate}
                    component={{
                        typography: {
                            sx: typographyStyle
                        }
                    }}
                >{renewalDate}</CustomTypography>
            </div>

        </div>
    )
}

export default OnHoldPlan
